import axios from 'axios';
import { LANG_SETLNG, GOOGLE_GET_PLACE } from '../actions/langConst'
import {app} from '../../main'
import {BehaviorSubject} from 'rxjs'

function onMapsReady() {
  state.RxGoogle.next(google.maps.places)
  // let map = new google.maps.Map(document.getElementById('map-canvas'), {center: {lat: 36.890257, lng: 30.707417}})
  // gService = new google.maps.places.PlacesService(map)
}

window.googleMapsReady=onMapsReady

function loadGoogleScript() {
  let oldScript = document.getElementById("google-maps-script");
  if(oldScript) {
    oldScript.parentNode.removeChild(oldScript);
    delete google.maps;
  }
  let script = document.createElement('script');
  script.id = "google-maps-script";
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places&language=${state.currentLng}&callback=googleMapsReady`;
  document.body.appendChild(script);
}

const state = {
  loopbackApi: process.env.VUE_APP_USTAGE_API || 'http://localhost:3000/api',
  // languages: [['en', 'English'], ['ru', 'Русский'], ['fr', 'Français']],
  languages: [['en', 'English'], ['ru', 'Русский']],
  currentLng: 'en',
  RxGoogle: new BehaviorSubject(null),
  RxLng: new BehaviorSubject('en'),
}

const getters = {
  languages: state => state.languages,
  currentLng: state => state.currentLng,
  RxGoogle: state => state.RxGoogle,
  RxLng: state => state.RxLng,
}

const actions = {
  [GOOGLE_GET_PLACE]: ({commit}, data) => {
    // console.log('Запрос!');
    return new Promise((resolve, reject) => {
      axios.get(state.loopbackApi + '/GooglePlaces/GetGooglePlace', {params: data.fields?{place_id: data.place_id, language: data.language, fields: data.fields}:{place_id: data.place_id, language: data.language}})
        .then((res)=>{
          resolve(res.data)
        })
        .catch(err=>{
          reject(err)
        })
    })
  },
  [LANG_SETLNG]: ({commit}, payload) => {
    commit(LANG_SETLNG, payload)
  }
}

const mutations = {
  [LANG_SETLNG]: (state, payload) => {
    if(state.currentLng !== payload) {
      app.$i18n.locale = payload
      state.currentLng = payload
      localStorage.setItem('ustage-language', payload)
      loadGoogleScript()
      state.RxLng.next(payload)
    }
  },
}

loadGoogleScript()

export default {
  state,
  getters,
  actions,
  mutations,
}
